import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://rzipcvrhqyxegvliugwn.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ6aXBjdnJocXl4ZWd2bGl1Z3duIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4ODkzNDgsImV4cCI6MjA5MzQ2NTM0OH0.GaVmxUjGXwS79IT-mcDSrAK8tOXNpNZJCezob_NcX00';

export const supabase = createClient(supabaseUrl, supabaseKey);
